// externals
import { useMediaQuery } from 'react-responsive';
import { useDispatch, useSelector } from 'react-redux';

// libraries
import { BreakPoint } from '@makemydeal/dr-activities-common';

// selectors / actions
import * as baseDealSelectors from '@makemydeal/dr-dash-store/selectors/BaseDealSelectors';
import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';

// components
import PurchaseHistorySection from './purchaseHistory/PurchaseHistorySection';

/*
 * The same wrapper the base-deal slideouts use (trade allowance, lender, rate, accessories,
 * protection product, via `SlideOutWrapper`). It fixes the content height so Interstate's footer
 * stays at the foot of the panel instead of floating under the last card, and gives the close
 * button its pointer cursor. Both are behaviours every other slideout in the app already has.
 */
import { SlideOutWithFixedFooter } from '../utils/SlideOutWithFixedFooter';

export const CustomerInsightsSlideOut = () => {
    const dispatch = useDispatch();
    const showCustomerInsights = useSelector(baseDealSelectors.getCustomerInsightsSlideoutStatus);

    const isTabletSize = useMediaQuery({ query: `(min-width: ${BreakPoint.PHONE}) and (max-width: 991px)` });
    const isLargeSize = useMediaQuery({ query: `(min-width: ${BreakPoint.MEDIUM})` });

    const getPanelWidth = () => {
        if (isTabletSize) return '32.857rem';
        if (isLargeSize) return '56.714rem';
        return '100%';
    };

    const closeCustomerInsights = () => {
        dispatch(baseDealActionCreators.setCustomerInsightsSlideoutStatus(false));
    };

    return (
        <SlideOutWithFixedFooter
            data-testid="customer-insights-slide-out"
            id="customer-insights-slide-out"
            show={showCustomerInsights}
            position="right"
            panelWidth={getPanelWidth()}
            header="Customer Insights"
            onHide={closeCustomerInsights}
            footer={{
                primary: {
                    action: closeCustomerInsights,
                    buttonStyle: 'secondary',
                    label: 'Back',
                    customIdentifiers: {
                        primaryButton: {
                            dataTestId: 'customer-insights-back-button'
                        }
                    }
                }
            }}
        >
            <PurchaseHistorySection />
        </SlideOutWithFixedFooter>
    );
};

export default CustomerInsightsSlideOut;
